import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import Markdown from "@irati/ui/src/Markdown"

export const Container = styled(Card)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({theme}) => css`
    gap: ${theme.spacing.four};
    background: linear-gradient(45deg, ${theme.colors.primary2} 0%, ${theme.colors.primary1} 100%);
  `}
`

export const ContainerImg = styled.img`
  max-height: 200px;

  @media (max-width: 1020px) {
    display: none;
  }
`

export const StyledMarkdown = styled(Markdown)`
  ${({theme}) => css`
    & h2 {
      color: ${theme.colors.greys.white};
      margin-bottom: ${theme.spacing.half};
    }

    & li::marker {
      color: ${theme.colors.greys.white};
    }

    & p {
      color: ${theme.colors.greys.white};
    }
    & ul {
      margin-bottom: ${theme.spacing.half};
    }
  `}
`
